export default __webpack_public_path__ + "static/media/pluss.607ac0a0.svg";